<template>
  <div
    class="home"
    :style="{ backgroundImage: 'url(' + require('@/assets/img/the-teeth-monsters-bg.jpg') + ')' }"
  >
    <img src="@/assets/img/teeth-monsters-logo.png" />
    <h1 class="title">Coming Soon</h1>
  </div>
</template>

<script>
export default {
  name: 'home',

  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
img {
  max-width: 80vw;
}
.title {
  color: $white;
  font-size: 3rem;
  padding: 5rem 1rem;

  text-align: center;
}

.home {
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
